import _ from 'lodash';
import {
  BrandFilterType,
  BuyerTypeFilter,
  CountyFilter,
  TaxFilter,
} from '../../../models/Filters';
import { PriceRange } from '../../../models/PriceRange';
import { ProductListModel } from '../../../models/Product';
import { FilterItem, TaxFilterItem } from './types';

export const mapToTaxFilterItems = (
  list: TaxFilter[] | undefined,
  selectedTaxClassIds: number[],
): TaxFilterItem[] => {
  const taxByTaxClass: { taxClassId: number; value: number }[] = _.orderBy(
    _.map(_.values(_.groupBy(list, i => i.taxClassId)), valueArr => {
      return {
        taxClassId: valueArr[0].taxClassId,
        value: _.sumBy(valueArr, v => v.rate),
      };
    }),
    ['value'],
    ['asc'],
  );
  const result = _.map(
    _.values(_.groupBy(taxByTaxClass, agg => agg.value)),
    group => {
      return {
        isChecked:
          _.intersection(
            selectedTaxClassIds,
            _.map(group, v => v.taxClassId),
          ).length > 0,
        taxClassIds: _.map(group, v => v.taxClassId),
        taxRate: group[0].value,
      };
    },
  );
  return result as TaxFilterItem[];
};

export const mapToBrandFilterItems = (
  list: BrandFilterType[] | undefined,
  selectedBrandsIds: number[],
): FilterItem[] => {
  return (
    list?.map(i => ({
      isChecked: selectedBrandsIds.includes(i.brandId),
      id: i.brandId,
      value: i.brandName,
    })) ?? []
  );
};

export const mapToBuyerTypeFilterItems = (
  list: BuyerTypeFilter[] | undefined,
  selectedBuyerTypes: number[],
): FilterItem[] => {
  return (
    list?.map(i => ({
      isChecked: selectedBuyerTypes.includes(i.buyerType),
      id: i.buyerType,
      value: i.name,
    })) ?? []
  );
};

export const mapToCountyFilterItems = (
  list: CountyFilter[] | undefined,
  selectedCountyIds: number[],
): FilterItem[] => {
  return (
    list?.map(i => ({
      isChecked: selectedCountyIds.includes(i.filterId),
      id: i.filterId,
      value: i.description,
    })) ?? []
  );
};

export const getSelectedFilterIds = (items: FilterItem[]): number[] => {
  return items.filter(i => i.isChecked).map(i => i.id);
};

export const getSelectedTaxClassIds = (items: TaxFilterItem[]): number[] => {
  let result: number[] = [];
  items
    .filter(i => i.isChecked)
    .forEach(i => (result = [..._.union(result, i.taxClassIds)]));
  return result;
};

export const hasPricesInRange = (
  products: ProductListModel[],
  range: PriceRange,
  priceRange: PriceRange,
): boolean => {
  if (range.min === priceRange.min || range.max === priceRange.max) {
    return true;
  }

  const productPrices = _.uniq(
    products.map(p => p.price.discountedPrice ?? p.price.defaultPrice),
  );

  return productPrices.some(price => price >= range.min && price <= range.max);
};
